import React, { useMemo } from 'react'

import { OrderBy } from '../../../../utils/constants'
import Cookies from 'js-cookie'
import { faEdit } from '@fortawesome/pro-solid-svg-icons'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { ActTypeCategory, getName } from '../../../../utils/entities/actTypeCategory'
import { Action, DeleteAction, TableActions } from '../../../../Components/antd/Tables/DataTable/utils/actions'
import DataTable from '../../../../Components/antd/Tables/DataTable/DataTable'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const ActCategoriesTable = ({ data, loading, maxHeight, metadata, parameters, school, user, onParametersChange, onTriggerAction, t }) => {
  const defaultMaxHeight = useMemo(() => `calc(100vh - ${Cookies.get('switch_user_id') ? '230px' : '189px'})`, [Cookies.get('switch_user_id')])
  const columns = useMemo(() => [
    { title: t('data_table.column_title.name'), orderBy: OrderBy.NAME, key: getName }
  ], [t])
  const actions = useMemo(() => [
    new Action({ title: 'act_type_categories_table.actions.edit', icon: faEdit, onClick: s => onTriggerAction(s, TableActions.EDIT_ACT_TYPE_CATEGORY) }),
    new DeleteAction({ title: 'act_type_categories_table.actions.delete', onDelete: s => onTriggerAction(s, TableActions.DELETE) })
  ], [onTriggerAction])

  return (
    <div style={{ height: maxHeight ?? defaultMaxHeight }}>
      <DataTable
        actions={actions}
        columns={columns}
        data={data}
        loading={loading}
        metadata={metadata}
        parameters={parameters}
        onCreate={() => onTriggerAction(new ActTypeCategory({ school }), TableActions.CREATE_ACT_TYPE_CATEGORY)}
        onParametersChange={onParametersChange}
      />
    </div>
  )
}

export default connect(mapStateToProps)(ActCategoriesTable)
